if (!customElements.get('sugarcloud-product')) {
  customElements.define('sugarcloud-product', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      const buttons = this.querySelectorAll('[data-image]');
      buttons.forEach(button => button.addEventListener('click', () => {
        this.querySelectorAll('[data-slide]').forEach(slide => { slide.hidden = slide.dataset.slide !== button.dataset.image; });
        buttons.forEach(other => other.setAttribute('aria-pressed', String(other === button)));
      }, options));
      const buy = this.querySelector('.am-form');
      const sticky = this.querySelector('.am-sticky');
      const cta = this.querySelector('[data-sticky-buy]');
      if (buy && sticky && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          const entry = entries[0];
          sticky.hidden = entry.isIntersecting;
        }, {threshold: 0});
        this.observer.observe(buy);
      }
      cta?.addEventListener('click', () => {
        const quantity = buy.querySelector('[name="quantity"]');
        if (quantity && !quantity.reportValidity()) {
          buy.scrollIntoView({block:'center'});
          return;
        }
        buy.requestSubmit(buy.querySelector('[name="add"]'));
      }, options);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.abort?.abort();
      this.initialized = false;
    }
  });
}
